import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

// import AutomationRuleAuditLogs from '@views/SocAutomation/soar/AutomationRuleAuditLogs';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/soc-automations/automation-rules/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.ShowAutomations];
    context.validatePermissions({ isAllowed, preload });
  },
});
